import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "overflow-auto pt-8px pb-8px" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  key: 0,
  class: "List"
}
const _hoisted_4 = {
  key: 1,
  class: "List"
}
const _hoisted_5 = {
  key: 2,
  class: "py-8px text-center text-12px text-[#999]"
}
const _hoisted_6 = {
  key: 3,
  class: "py-8px text-center text-12px text-[#999]"
}
const _hoisted_7 = { key: 1 }

import { onMounted, ref } from 'vue'
import { ArrowDown, Search, ArrowLeft } from '@element-plus/icons-vue'
import { getMaterialsItems } from '@/api/affairs'
import { ElIcon, ElInput, ElButton, ElPagination, ElEmpty, ElSkeleton, ElSkeletonItem } from 'element-plus'
// @ts-ignore
import elementItem from './elmentItem.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'elementlist',
  props: {
    category: {}
  },
  emits: ["back"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props
const searchValue = ref('')
const selectedCategory = ref('all') // 默认选中"全部"
const title = ref('')
let page = ref({
    pageNum: 1,
    pageSize: 50,
    type: 1,
})
const listItems = ref([]);
const loading = ref(true);
const pagetotle = ref(0);
const scrollRef = ref<HTMLElement | null>(null)
const loadingMore = ref(false)
const hasMore = ref(true)
const currentPage = ref(1)
const pageSize = ref(50)
const resetPagination = () => {
    page.value.pageNum = 1;
    pagetotle.value = 0;
    listItems.value = [];
}

onMounted(() => {
    getList(1, false)
})
const allpage = ref(1)

const getList = (pageNo = 1, append = false) => {
    if (!append) loading.value = true
    loadingMore.value = append
    getMaterialsItems({ pageNum: pageNo, pageSize: pageSize.value, type: 2, category_id: props.category.id, name: searchValue.value }).then(res => {
        const items = res?.data?.data?.items || []
        if (append) {
            listItems.value = listItems.value.concat(items)
        } else {
            listItems.value = items
        }
        allpage.value = res?.data?.data?.total_pages || allpage.value
        hasMore.value = pageNo < allpage.value
    }).finally(() => {
        loading.value = false
        loadingMore.value = false
    })
}

const emit = __emit
const handleBack = () => {
    emit('back')
}

const pagesearch = (val) => {
    searchValue.value = val
    resetPagination()
    currentPage.value = 1
    hasMore.value = true
    getList(1, false)
}
const onScroll = (e: Event) => {
    const el = (e.target as HTMLElement) || scrollRef.value
    if (!el || !hasMore.value || loadingMore.value) return
    const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 16
    if (nearBottom) {
        currentPage.value += 1
        getList(currentPage.value, true)
    }
}
__expose({ pagesearch })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.category)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "header flex items-center gap-8px cursor-pointer",
          onClick: handleBack
        }, [
          _createVNode(_unref(ElIcon), { class: "back-icon cursor-pointer" }, {
            default: _withCtx(() => [
              _createVNode(_unref(ArrowLeft))
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, _toDisplayString(props.category.name), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "pageList",
      ref_key: "scrollRef",
      ref: scrollRef,
      onScroll: onScroll
    }, [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(9, (n) => {
              return _createElementVNode("div", {
                key: n,
                class: "image-item"
              }, [
                _createVNode(_unref(ElSkeleton), { animated: "" }, {
                  template: _withCtx(() => [
                    _createVNode(_unref(ElSkeletonItem), {
                      variant: "image",
                      class: "skeleton-img"
                    })
                  ]),
                  _: 1
                })
              ])
            }), 64))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listItems.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                class: "image-item"
              }, [
                _createVNode(elementItem, { template: item }, null, 8, ["template"])
              ]))
            }), 128))
          ])),
      (loadingMore.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, "加载中..."))
        : (!hasMore.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, "已无更多"))
          : _createCommentVNode("", true)
    ], 544),
    (listItems.value.length === 0 && !loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_unref(ElEmpty), { description: "暂无数据" })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})